import React from 'react';

const UserIcon = () => {
	return (
		<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path d='M10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0ZM10 4.5C11.7 4.5 13 5.8 13 7.5C13 9.2 11.7 10.5 10 10.5C8.3 10.5 7 9.2 7 7.5C7 5.8 8.3 4.5 10 4.5ZM10 18C7.8 18 5.8 17.1 4.4 15.7C5.5 13.8 7.6 12.5 10 12.5C12.4 12.5 14.5 13.8 15.6 15.7C14.2 17.1 12.2 18 10 18Z' />
		</svg>
	);
};

export default UserIcon;
